import { render, staticRenderFns } from "./No06.vue?vue&type=template&id=1a3c130c&scoped=true"
import script from "./No06.vue?vue&type=script&lang=js"
export * from "./No06.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3c130c",
  null
  
)

export default component.exports